import React from 'react'

export default function Skeleton() {
  return (
    <div className="flex flex-col gap-4 animate-pulse">
      <div className="px-2 py-2 w-52 h-10 flex cursor-pointer bg-gray-100 dark:bg-gray-500 rounded"></div>
      <div className="px-2 py-2 h-40 flex cursor-pointer bg-gray-100 dark:bg-gray-500 rounded"></div>
    </div>
  )
}
